/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const TEST_TOOL_DATA_IDS = {
  closeButton: `Dialog button: Close`,
  testButton: `Dialog button: Test`,
};
